type AnchorProps = {
  anchorId: string
}

export function Anchor({ anchorId }: AnchorProps) {
  if (!anchorId) {
    return null
  }

  return <div id={anchorId} data-anchor-expose="true" />
}
